import axios from 'axios'
import { api } from '@/services/config'
import moment from 'moment'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const addEdit = {
  namespaced: true,
  state: () => ({
    addKbli: false,
    subKbliEdit: false,
    showEditInfo: false,
    choosedIujp: [],
    choosedSbujk: [],
    choosedIujptl: [],

    informasi: {},
    vendor_id: '',
    vendorName: '',
    pemilikBank: '',
    badan_usaha_id: '',
    tglBerdiri: '',

    isupplier_code: '',
    ariba_code: '',
    bce_code: '',
    gems_code: '',
    bkes_code: '',
    address: '',

    provinsi_asing: '',
    kota_asing: '',
    kode_pos_asing: '',
    choosedCountry: null,
    choosedProvince: null,
    choosedCity: null,
    choosedDistric: null,
    choosedVillage: null,
    kodepos: '',

    phoneCode: '',
    phoneNumber: '',
    emailPerusahaan: '',
    selectedBank: '',
    bankBranchOffice: '',
    mataUang: '',
    accountNumber: '',
    npwpBank: '',

    iujp: [],
    iujptl: [],

    isAddPic: false,
    picDetail: null,
  }),
  mutations: {
    ADD_EDIT_MODAL(state, data) {
      state[data.name] = data.status
    },
    SET_STATE_DATA(state, data) {
      state[data.name] = data.value
    },
    SET_INFO(state, info) {
      state.informasi = info

      state.vendorName = info.nama_vendor
      state.badan_usaha_id = info.badan_usaha.id
      state.tglBerdiri = mixin.methods.formatDateInput(info.tanggal_berdiri)

      state.isupplier_code = info.isupplier_code
      state.ariba_code = info.ariba_code
      state.bce_code = info.bce_code
      state.gems_code = info.gems_code
      state.bkes_code = info.bkes_code
      state.address = info.alamat

      state.choosedCountry = info.negara
      state.choosedProvince = info.provinsi
      state.choosedCity = info.kota
      state.choosedDistric = info.kecamatan
      state.choosedVillage = info.kelurahan
      state.kodepos = info.kelurahan.kodepos

      state.phoneCode = ''
      state.phoneNumber = info.no_handphone
      state.emailPerusahaan = info.email
      state.selectedBank = info.bank
      state.bankBranchOffice = info.kantor_cabang
      state.mataUang = info.mata_uang
      state.accountNumber = info.no_rekening
      state.npwpBank = info.no_npwp
    },
    SET_CHECKED(state, checked) {
      state[checked.name] = checked.filter
    },
  },
  actions: {
    async getInformasi({ commit }, payload) {
      try {
        const url = `${api}/api/v1/d-vendor-informasi?id=${payload &&
          payload.vendor_id}`

        const { data } = await axios({
          method: 'GET',
          url,
        })
        await commit('SET_STATE_DATA', {
          name: 'vendor_id',
          value: payload.vendor_id,
        })
        await commit('SET_INFO', data.data)
      } catch (error) {}
    },
    async updateInformation({ state }) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-informasi/${state.vendor_id}`
        let update = {
          badan_usaha_id: state.badan_usaha_id,
          nama_vendor: state.vendorName,
          tanggal_berdiri: state.tglBerdiri,
          alamat: state.address,
          negara_id: mixin.methods.$get(state, 'choosedCountry.id'),
          provinsi_id: mixin.methods.$get(state, 'choosedProvince.id'),
          kota_id: mixin.methods.$get(state, 'choosedCity.id'),
          kecamatan_id: mixin.methods.$get(state, 'choosedDistric.id'),
          kelurahan_id: mixin.methods.$get(state, 'choosedVillage.id'),
          no_handphone: state.phoneNumber,
          email: state.emailPerusahaan,
          nama_pemilik_rekening: state.vendorName,
          bank: state.selectedBank,
          kantor_cabang: state.bankBranchOffice,
          no_rekening: state.accountNumber,
          mata_uang: state.mataUang,
          no_npwp: state.npwpBank,
          ariba_code: state.ariba_code,
          bce_code: state.bce_code,
          gems_code: state.gems_code,
          bkes_code: state.bkes_code,
          isupplier_code: state.isupplier_code,
        }

        let json = JSON.stringify(update)
        const { data } = await axios.put(url, json, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        await store.commit('SET_NOTIF', data.status)
        await store.commit('addEdit/ADD_EDIT_MODAL', {
          name: 'showEditInfo',
          status: false,
        })
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async addItemKbli({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-kbli`
        let created = payload.kbliData

        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            vendor_id: payload.vendor_id,
            kbli_parent_id: created.parent_id,
            kbli_sub_id: created.id,
            nib: false,
            ss_izin: false,
            dokumen_lainnya: false,
          },
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteKbli({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-kbli/${payload.kbli_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemIujp({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-iujp`
        let created = payload.iujpData

        let dataInput = {
          vendor_id: payload.vendor_id,
          iujp_id: created.id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteIujp({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-iujp/${payload.iujp_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemSbujk({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-sbujk`

        let dataInput = {
          vendor_id: payload.vendor_id,
          sbujk_id: payload.sbujk_id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteSbujk({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        let url = `${api}/api/v1/d-vendor-sbujk/${payload.sbujk_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addItemIujptl({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-iujptl`

        let dataInput = {
          vendor_id: payload.vendor_id,
          iujptl_id: payload.iujptl_id,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })

        if (data && data.data) {
          await payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async deleteIujptl({}, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        let url = `${api}/api/v1/d-vendor-iujptl/${payload.iujptl_id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        await payload.onSuccess()
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', 'Error')
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },

    async addPIC({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pic`

        let dataInput = {
          vendor_id: payload.vendor_id,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'POST',
          url,
          data: dataInput,
        })
        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_PIC_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'picDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddPic', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
    async editPIC({ commit }, payload) {
      await store.commit('level1/SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-pic/${payload.id}`

        let dataInput = {
          vendor_id: payload.vendor_id,
          nama: payload.nama,
          no_handphone: payload.no_handphone,
          email: payload.email,
        }

        const { data } = await axios({
          method: 'PUT',
          url,
          data: dataInput,
        })

        if (data && data.status == 'success') {
          payload && payload.onSuccess()
        }
        await store.commit('SET_NOTIF', `${data.message}`)
        await store.commit('level1/SET_LOADING', false)
        await store.commit('modalStore/SET_PIC_MODAL', false)
        await commit('SET_STATE_DATA', { name: 'picDetail', value: null })
        await commit('SET_STATE_DATA', { name: 'isAddPic', value: false })
      } catch (error) {
        await store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'data.message', `Error`)
        )
        await store.commit('level1/SET_LOADING', false)
      }
    },
  },
}

export default addEdit
